import React, { FC } from 'react'
import cx from 'classnames'
import descifraLogo from 'assets/images/descifraLogo.svg'
import styles from './Logo.module.scss'

export const SIZES = ['md', 'lg'] as const
type Size = typeof SIZES[number]

type LogoProps = {
  size?: Size
}

export const Logo: FC<LogoProps> = ({ size = 'md' }) => {
  const classes = cx({
    [styles.logo]: true,
    [styles[size]]: size,
  })

  return <img src={descifraLogo} className={classes} alt="" />
}

Logo.displayName = 'Logo'
